import { Box, Grid, useMediaQuery, useTheme } from '@material-ui/core';
import Button from 'components/Button';
import {
  StyledCaption,
  StyledCard,
  StyledGrid,
  StyledIcon,
  StyledLongBody,
} from 'components/ItemInfoCard/styles';
import { BasicInfoCardProps } from 'components/ItemInfoCard/types';
import { Captions } from 'components/Typography';
import { pushTo } from 'helpers/routes';
import { AssuranceIcon } from 'images';
import { sanlamDarkBlue } from 'Material-UI/colors';
import React from 'react';
import { uppercase } from 'utils/string';

const BasicInfoCard = (props: BasicInfoCardProps) => {
  const {
    styles,
    Key1Label,
    Key1Value,
    Key2Label,
    Key2Value,
    title,
    buttonLabel,
    wrapperPaddingLeft,
    wrapperPaddingRight,
    redirectionPath,
  } = props;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  return (
    <StyledCard
      backgroundImage={styles.backgroundImage}
      backgroundColor={styles.backgroundColor}
      paddingLeft={wrapperPaddingLeft}
      paddingRight={wrapperPaddingRight}
    >
      <StyledGrid
        container
        alignItems="center"
        justify="space-between"
        marginBottom="17px"
      >
        <Grid item xs={6}>
          <Grid container alignItems="center">
            {styles.icon && (
              <StyledGrid item xs={3} textAlign="center" height="30px">
                <StyledIcon
                  width="34px"
                  height="34px"
                  src={AssuranceIcon[styles.icon]}
                  alt="item-icon"
                />
              </StyledGrid>
            )}
            <Grid item xs={9}>
              <Box paddingLeft="6px" paddingTop="6px">
                <StyledLongBody matches={matches} color={styles.titleColor}>
                  {uppercase(title || '')}
                </StyledLongBody>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </StyledGrid>
      <Grid container justify="space-between">
        <Grid container justify="space-between">
          <Grid item xs={6}>
            <StyledCaption
              color={styles.labelsColor || '#9797AF'}
              marginBottom="6px"
            >
              {uppercase(Key1Label)}
            </StyledCaption>
          </Grid>
          <Grid item xs={6}>
            <StyledCaption
              color={styles.valuesColor || sanlamDarkBlue}
              weight="bold"
              marginBottom="6px"
              textAlign="end"
            >
              {Key1Value}
            </StyledCaption>
          </Grid>
        </Grid>
        <Grid container justify="space-between">
          <Grid item xs={6}>
            <Captions color={styles.labelsColor || '#9797AF'}>
              {uppercase(Key2Label)}
            </Captions>
          </Grid>
          <Grid item xs={6}>
            <StyledCaption
              color={styles.valuesColor || sanlamDarkBlue}
              weight="bold"
              textAlign="end"
              marginBottom="15px"
            >
              {Key2Value}
            </StyledCaption>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={4}>
            <Button
              variant="outlined"
              className={styles.buttonRootStyles}
              size="small"
              onClick={() => pushTo(redirectionPath)}
            >
              {buttonLabel}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </StyledCard>
  );
};

export default BasicInfoCard;
